header {
	/* Dimensions */
	height: 58px;
	width: 100%;

	/* BG */
	background-color: var(--menu-background-color);

	/* Border */
	border-color: var(--border-color);
	border-style: solid;
	border-width: 0px 0px 1px 0px;

	/* Spacing */
	padding: 0px 10px 0px 10px;

	/* Flex */
	display: flex;
	align-items: center;

	/* Box Model */
	box-sizing: border-box;
}

section {
	flex-grow: 1;
	display: flex;
	justify-content: flex-end;
	align-items: center;
	gap: 10px;
}

img {
	width: 141px;
	height: 49px;
}

a {
	display: flex;
	align-items: center;
}

.userButton:hover {
	filter: brightness(0.9);
}